<div *ngIf="shouldDisplay" class="audience-size-container">
  <div class="audience-size-message" [class.critical]="isCritical" [class.warning]="!isCritical">
    <div class="content">
      <div class="description">
        <ng-container *ngIf="isCritical">
          Your audience has <strong>{{ formattedSize }} people</strong>, but we need at least
          <strong>10K</strong> to run campaigns.
        </ng-container>
        <ng-container *ngIf="!isCritical">
          Your audience has <strong>{{ formattedSize }} people</strong>. You can proceed, but
          reaching <strong>50K+</strong> will give you better results.
        </ng-container>
      </div>
    </div>
  </div>
  <div class="message-time">
    {{ formattedTime }}
  </div>
</div>
